import { render, staticRenderFns } from "./billing-information-popup.vue?vue&type=template&id=2c2bc86c"
import script from "./billing-information-popup.vue?vue&type=script&lang=js"
export * from "./billing-information-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2bc86c')) {
      api.createRecord('2c2bc86c', component.options)
    } else {
      api.reload('2c2bc86c', component.options)
    }
    module.hot.accept("./billing-information-popup.vue?vue&type=template&id=2c2bc86c", function () {
      api.rerender('2c2bc86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/billing-information-popup.vue"
export default component.exports